module.exports = __webpack_public_path__ + "static/media/november.74e00317.png";